<template>
  <v-row class="pa-0">
    <v-col class="py-0" v-if="!onlyTime">
      <v-menu
        v-model="menuDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="localDateFormatted"
            :disabled="disejblano"
            :label="labelDate"
            prepend-icon="far fa-calendar-alt"
            v-on="on"
            @blur="localDate = parseDate(localDateFormatted)"
          >
            <v-tooltip slot="append" top>
              <template v-slot:activator="{ on }">
                <v-btn icon small @click="selectToday" v-on="on">
                  <v-icon small>
                    mdi-calendar-today
                  </v-icon>
                </v-btn>
              </template>
              <span>Danes</span>
            </v-tooltip>
          </v-text-field>
        </template>
        <v-date-picker
          v-model="localDate"
          locale="sl-SI"
          first-day-of-week="1"

          @input="menuDate = false">
        </v-date-picker>
      </v-menu>
    </v-col>
    <v-col class="py-0">
      <v-menu
        ref="menu"
        v-model="menuTime"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="localTime"
        transition="scale-transition"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :disabled="disejblano"
            v-model="localTime"
            :label="!onlyTime ? '' : labelDate"
            prepend-icon="far fa-clock"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="menuTime"
          v-model="localTime"
          format="24hr"
          full-width
          @click:minute="$refs.menu.save(localTime)"
        ></v-time-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    date: {
      required: true,
      type: String
    },
    time: {
      required: true,
      type: String
    },
    labelDate: {
      default: 'Datum',
      type: String
    },
    disejblano: {
      required: true,
      default: false,
      type: Boolean
    },
    onlyTime: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      menuDate: false,
      menuTime: false,
      localDateFormatted: this.formatDate(this.date),
      localDate: this.date,
      localTime: this.time
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    selectToday () {
      this.localDate = moment().format('YYYY-MM-DD')
    },
    resetTime (setTime) {
      this.localTime = setTime
    }
  },
  watch: {
    localDate (date) {
      this.localDateFormatted = this.formatDate(this.localDate)
      this.$emit('change', { date: this.localDate, time: this.localTime })
    },
    localTime (time) {
      this.$emit('change', { date: this.localDate, time: this.localTime })
    }
  }
}
</script>
